module.exports = __webpack_public_path__ + "img/beta_en.58cce0c1.png";